import { lazy } from 'react';

// Lazy load all route components for code splitting
const HomeTwo = lazy(() => import("./HomeTwo"));
const Markets = lazy(() => import("./Markets"));
const Logout = lazy(() => import("./Logout"));
const Deposit = lazy(() => import("./Deposit"));
const Wallet = lazy(() => import("./Wallet"));
const UserProfile = lazy(() => import("./UserProfile"));
const Login = lazy(() => import("./Login"));
const Register = lazy(() => import("./Register"));
const Contact = lazy(() => import("./Contact"));
const Faq = lazy(() => import("./Faq"));
const Trade = lazy(() => import("./trade"));
const Withdrawal = lazy(() => import("./Withdrawal"));

const Refferal = lazy(() => import("./Refferal"));
const Coinlisting = lazy(() => import("./Coinlisting"));
const CoinPricing = lazy(() => import("./CoinPricing"));
const PartnerAuthenticity = lazy(() => import("./PartnerAuthenticity"));
const ListingForm = lazy(() => import("./ListingForm"));
const Launchpad = lazy(() => import("./Launchpad"));
const Airdrop = lazy(() => import("./Airdrop"));
const Staking = lazy(() => import("./Staking"));
const About = lazy(() => import("./about"));
const Fee = lazy(() => import("./fee"));
const Privacy = lazy(() => import("./Privacy"));
const TermsOfUse = lazy(() => import("./TermsOfUse"));
const Forget = lazy(() => import("./forget"));
const TopGainers = lazy(() => import("../components/marketlist/topgainers"));
const TopLosers = lazy(() => import("../components/marketlist/toplosers"));
const NewlyListed = lazy(() => import("../components/marketlist/newlylisted"));
const Blockchain = lazy(() => import("../components/marketlist/blockchain"));
const Defi = lazy(() => import("../components/marketlist/defi"));
const Memecoin = lazy(() => import("../components/marketlist/memecoin"));
const LaunchPad2 = lazy(() => import("../components/launchpad/Launchpad2"));

const routes = [
  { path: '/', component: <HomeTwo />},
  { path: '/markets', component: <Markets />},
  { path: '/crypto-deposit', component: <Deposit />},
  { path: '/deposit-history', component: <Deposit />},
  { path: '/wallet', component: <Wallet />},
  { path: '/user-profile', component: <UserProfile />},
  { path: '/login', component: <Login />},
  { path: '/create-account/:id?', component: <Register />},
  { path: '/contact', component: <Contact />},
  { path: '/faq', component: <Faq />},
  { path: '/trade/:id', component: <Trade />},
  { path: '/crypto-withdrawal', component: <Withdrawal />},
  { path: '/withdrawal-history', component: <Withdrawal />},
  { path: '/logout', component: <Logout/>},
  { path: '/referral-program', component: <Refferal/>},
  { path: '/coin-listing', component: <Coinlisting/>},
  { path: '/listing-price', component: <CoinPricing/>},
  { path: '/official-authenticity', component: <PartnerAuthenticity/>},
  { path: '/listing-form', component: <ListingForm/>},
  { path: '/launchpad', component: <Launchpad/>},
  { path: '/airdrop', component: <Airdrop/>},
  { path: '/staking', component: <Staking/>},
  { path: '/about-cetoex', component: <About/>},
  { path: '/fee-schedule', component: <Fee/>},
  { path: '/privacy', component: <Privacy/>},
  { path: '/terms-of-use', component: <TermsOfUse/>},
  { path: '/forgot-password', component: <Forget/>},
  { path: '/top-gainers', component: <TopGainers/>},
  { path: '/top-losers', component: <TopLosers/>},
  { path: '/newly-listed', component: <NewlyListed/>},
  { path: '/blockchain', component: <Blockchain/>},
  { path: '/de-fi', component: <Defi/>},
  { path: '/memecoin', component: <Memecoin/>},
  { path: '/launchpad/:id', component: <LaunchPad2/>},
];

export default routes;